import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd/lib/index';
import { LocalizationContext } from '../../hoc/Localization';
import TitleContent from '../TinyComponents/TitleContent';
import Gallery from '../Gallery';
import SchoolLink from '../TinyComponents/SchoolLink';
import styles from './styles.less';
import InlineEditor from '../InlineEditor';
import { RouteContext } from '../../hoc/Route';
import { EditorContext } from '../../hoc/Editor';
import MarkDown from '../TinyComponents/MarkDown';

const Content = ({ school }) => {
  const { page } = React.useContext(RouteContext);
  const { t, locale } = React.useContext(LocalizationContext);
  return (
    <div>
      <div className={styles.schoolLink}>
        <SchoolLink school={school} />
      </div>
      <div>
        {page === 'school' || page === 'schoolEdit' || page === 'createSchool' ? (
          <InlineEditor
            label="description"
            type="wysiwyg"
            value={school.description || school[`description_${locale}`]}
            hasTranslations
            settings={{
              placeholder: t('school.edit.description.placeholder'),
              data_gh: 'school_edit_description_textarea',
            }}
          >
            <MarkDown source={school.description} />
          </InlineEditor>
        ) : (
          <MarkDown source={school.description} />
        )}
      </div>
    </div>
  );
};

Content.propTypes = {
  school: PropTypes.object.isRequired,
};

const SchoolInfo = ({ school, canEdit, schoolGalleryHidden }) => {
  const { t, translate } = React.useContext(LocalizationContext);
  const { editMode } = React.useContext(EditorContext);
  const { page } = React.useContext(RouteContext);
  return (
    <Row id="schoolInfo" type="flex" gutter={20} className={styles.row}>
      {((school && translate(school, 'description')) || (canEdit && editMode)) && (
        <Col className={`${styles.about} ${styles.col}`} xs={24} md={12}>
          <TitleContent title={t('details.about')} content={<Content school={school} />} />
        </Col>
      )}

      {((((school && school.images) || (canEdit && editMode)) && !schoolGalleryHidden) ||
        page === 'createSchool') && (
        <Col className={`${styles.gallery} ${styles.col}`} xs={24} md={12}>
          {((school.images && school.images.length >= 1) || page === 'createSchool') && (
            <TitleContent
              title={t('details.gallery')}
              content={<Gallery images={school.images} canEdit={canEdit} />}
            />
          )}
        </Col>
      )}
    </Row>
  );
};

SchoolInfo.propTypes = {
  school: PropTypes.object.isRequired,
  canEdit: PropTypes.bool,
  schoolGalleryHidden: PropTypes.bool,
};

SchoolInfo.defaultProps = {
  canEdit: false,
  schoolGalleryHidden: false,
};

export default SchoolInfo;
